/* 🤖 this file was generated by svg-to-ts */
export const matIconSortByAlpha: {
  name: 'sort-by-alpha';
  data: string;
} = {
  name: 'sort-by-alpha',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14.94 4.66h-4.72l2.36-2.36 2.36 2.36zm-4.69 14.71h4.66l-2.33 2.33-2.33-2.33zM6.1 6.27 1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37 1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"/></svg>`
};
